export default __webpack_public_path__ + "static/3-59f27bfedee8df5eb45c53141c61dbc5.png";